import styled from '@emotion/styled'

import {cssTheme} from '../../../themes'
import {NoStyleButton} from '../helpers/NoStyleButton'

export const FooterLink = styled.a`
  ${cssTheme.typography.bodyXS};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
    color: ${cssTheme.colors.content.neutral.secondary};
  }

  &:active {
    text-decoration: none;
    color: ${cssTheme.colors.content.neutral.secondary};
  }

  &:focus-visible {
    outline: 1px solid ${cssTheme.colors.border.neutral.secondary};
  }
`

export const FooterLinkButton = styled(NoStyleButton)`
  ${cssTheme.typography.bodyXS};

  &:hover {
    text-decoration: underline;
    color: ${cssTheme.colors.content.neutral.secondary};
  }

  &:active {
    text-decoration: none;
    color: ${cssTheme.colors.content.neutral.disabled};
  }

  &:focus-visible {
    outline: 1px solid ${cssTheme.colors.border.neutral.primaryHover};
  }
`
